//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.BooleanOperation.js";
import "../GeometricUtilities/GeometricUtilities.FeatureOptions.js";
import "../GeometricUtilities/GeometricUtilities.Limits.js";
import "../GeometricUtilities/GeometricUtilities.FeatureOffset.js";
import "../GeometricUtilities/GeometricUtilities.SmartVolumeProfileBuilder.js";
import "../no/GeometricUtilities.js";
let d=[[[0,"Axis",1,"Axis",0],[1,"BooleanOperation",0,"GeometricUtilities.BooleanOperation",0],[1,"FeatureOptions",0,"GeometricUtilities.FeatureOptions",0],[1,"Limits",0,"GeometricUtilities.Limits",0],[1,"Offset",0,"GeometricUtilities.FeatureOffset",0],[0,"Section",1,"Section",0],[1,"SmartVolumeProfile",0,"GeometricUtilities.SmartVolumeProfileBuilder",0],[0,"Tolerance",1,0]],[[["startHelperPoint"],"SetStartLimitHelperPoint",{},1,0],[["endHelperPoint"],"SetEndLimitHelperPoint",{},1,0]],[]];
SPLM.Features.RevolveBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.RevolveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;